import { render, staticRenderFns } from "./hljnyzyjsxy.vue?vue&type=template&id=2148bcc6&scoped=true&"
import script from "./hljnyzyjsxy.vue?vue&type=script&lang=js&"
export * from "./hljnyzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./hljnyzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./hljnyzyjsxy.vue?vue&type=style&index=1&id=2148bcc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148bcc6",
  null
  
)

export default component.exports